import React, { memo } from 'react';
import * as Variants from './IconVariants/index';

export const IconsVariants = {
  ARROW_UP: 'ArrowUp',
  BELL_FULL: 'BellFull',
  BOOKMARK: 'BookMark',
  BOOKMARK_FULL: 'BookMarkFull',
  CALENDAR: 'Calendar',
  COMMENT: 'Comment',
  DISLIKE: 'Dislike',
  EDIT: 'Edit',
  DISLIKE_FULL: 'DislikeFull',
  EYE: 'Eye',
  EYE_FULL: 'EyeFull',
  EYE_FULL_SLASH: 'EyeFullSlash',
  HOME_FULL: 'HomeFull',
  ID_CARD: 'IdCard',
  LAYER: 'Layer',
  GLASS: 'Glass',
  HAMBURGER: 'Hamburger',
  HAMBURGER_2: 'Hamburger2',
  HEART_FULL: 'HeartFull',
  LIKE: 'Like',
  LIKE_FULL: 'LikeFull',
  LOCATION: 'Location',
  PLUS_SQUARE: 'PlusSquare',
  POWER_OFF: 'PowerOff',
  PROFILE_FULL: 'ProfileFull',
  SHARE: 'Share',
  SHARE_ARROW: 'ShareArrow',
  SHARE_FULL: 'ShareFull',
  USER_FULL: 'UserFull',
  X: 'X',
  INFO: 'Info',
} as const;

type IconVariantName = typeof IconsVariants[keyof typeof IconsVariants];

interface IconsProps {
  variant: IconVariantName | string;
  classes?: string;
  styles?: string;
  style?: React.CSSProperties;
  children?: React.ReactNode;
  forwardRef?: React.RefObject<HTMLElement | null>;
}

export const Icons: React.FC<IconsProps> = memo((props) => {
  const { variant, ...rest } = props;
  const VariantComponent = Variants[variant as keyof typeof Variants] as React.ComponentType<Record<string, unknown>> | undefined;

  if (!VariantComponent) {
    return <div>There is missing variant for {variant}</div>;
  }

  return (
    <VariantComponent {...rest}>
      {props.children}
    </VariantComponent>
  );
});

Icons.displayName = 'Icons';
